export const theme = {
  cartItemContainerBorder: '',
  cartItemDescriptionColor: Styles.color.grey.one,
  headerColor: Styles.color.grey.four,
};
